// Salseforce ui-kit theme css
  
// import "./App.css";
// import "./Admin.css";
import "./ReactToastify.css";
import "react-image-lightbox/style.css";
import "react-h5-audio-player/lib/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-awesome-lightbox/build/style.css";
import "font-awesome/css/font-awesome.min.css";
import "@salesforce-ux/design-system/assets/styles/salesforce-lightning-design-system.min.css"

import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { persistor, store } from "./app/redux/store";
import { Auth } from "./app/views/Auth";
import SsoCallback from "./app/views/Auth/SsoCallback/SsoCallback";
import EmailCourseStart from "./app/views/Auth/EmailCourseStart/EmailCourseStart";
import ExternalUserFormView from "./app/views/ExternalSurveryForm/ExternalUserFormView";
import PublicSurvey from "./app/views/Survey/components/users/PublicSurvey";
import { IRAReport } from "./app/views/Ira";
import Market from "./app/views/MarketForm/Market";
import { NMReport } from "./app/views/Nm";
import { PersistGate } from "redux-persist/integration/react";
import Preloader from "./app/shared/components/Preloader";
import { Provider } from "react-redux";
import React from "react";
import { ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";

import 'assets/styles/_helperGuide.scss';
// import 'assets/styles/_app.scss';
// import 'assets/styles/_admin.scss'



import { Chart, ArcElement, LinearScale, Tooltip, Legend, Title, CategoryScale, BarElement, PointElement, LineElement } from 'chart.js';

//constants
import { routeConstants } from "app/shared/constants/routeConstants";
import ExternalReportModal from "app/shared/components/ReportModal/ExternalReportIndex";
import ExternalThoughtModal from "app/shared/components/ReportModal/ExternalThoughtModal";
import ExternalPollModal from "app/shared/components/ReportModal/ExternalPollModal";
import ThankYouSafetyPage from "app/shared/components/ReportModal/ExternalThankYouPage";
Chart.register(ArcElement, PointElement, LineElement, CategoryScale, BarElement, LinearScale, Tooltip, Legend, Title);
const SidebarLayout = React.lazy(() =>
  import("app/shared/components/Layouts/SidebarLayout/SidebarLayout")
);

//V2 sidebar layout
const SidebarLayoutV2 = React.lazy(() =>
  import("app/shared/components/Layouts/SidebarLayoutV2")
);
const AdminSidebarLayout = React.lazy(() =>
  import("app/shared/components/Layouts/AdminSidebarLayout/AdminSidebarLayout")
);
const SafetyAdminSidebarLayout = React.lazy(() =>
  import("app/shared/components/Layouts/SafetyAdminSidebarLayout/SafetyAdminSidebarLayout")
);
const PrivateRoute = React.lazy(() =>
  import("app/shared/components/Authentication/PrivateRoute")
);






const PageNotFound = () => {
  return (
    <div className="page-not-found">
      <div className="inner-text">
        <h1>404</h1>
        <h2>Page Not Found</h2>
      </div>
    </div>
  );
};

// Renders the correct sidebar layout for /legal-register routes
// based on the logged-in user's designation_flag:
//   designation_flag == 5 → Plant Safety Head → SafetyAdminSidebarLayout
//   all other admins      → AdminSidebarLayout
const LegalRegisterLayout = () => {
  const userInfo = JSON.parse(localStorage.getItem("userData") || "{}");
  if (userInfo.designation_flag == 5) {
    return <SafetyAdminSidebarLayout />;
  }
  return <AdminSidebarLayout />;
};

const RightsMatrix = React.lazy(() => import('app/views/Admin/Users/RightsMatrix'));


const menuItem = [
  "/userside-user",
  "/userside-hira",
  "/userside-safetyteam",
  "/userside-master",
];

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <React.Suspense fallback={<Preloader />}>
          <Router>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnVisibilityChange
              draggable
              pauseOnHover
            />
            <Switch>
              <PrivateRoute exact path="/">
                <SidebarLayoutV2 />
              </PrivateRoute>
              {/* <PrivateRoute exact path="/v2/">
                
                <SidebarLayoutV2 />
              </PrivateRoute> */}
              <PrivateRoute path={routeConstants.userPoral}>
              
                <SidebarLayoutV2 />
              </PrivateRoute>
              {/* <PrivateRoute path={generateV2Routest(SIDEBAR_ROUTE_PATHS)}>                
                <SidebarLayoutV2 />
              </PrivateRoute> */}

              <PrivateRoute path="/ira-report/:id">
                <IRAReport />
              </PrivateRoute>
              <PrivateRoute path="/nm-report/:id">
                <NMReport />
              </PrivateRoute>

              {menuItem.map((linkItem, index) => (
                <PrivateRoute path={linkItem} key={`menuLink-${index}`}>
                  <SidebarLayout />
                </PrivateRoute>
              ))}
            

              {/* Legal Register — render SafetyAdminSidebarLayout for Plant Safety Head
                  (designation_flag == 5), AdminSidebarLayout for all other admins */}
              <PrivateRoute path="/legal-register">
                <LegalRegisterLayout />
              </PrivateRoute>

              {/* Safety Admin routes */}
              <PrivateRoute path={routeConstants.safetyAdminPortal}>
                <SafetyAdminSidebarLayout />
              </PrivateRoute>

              {/* Admin routes */}
              <PrivateRoute path={routeConstants.adminPortal}>
                <AdminSidebarLayout />
              </PrivateRoute>

              {/* SSO callback — must be public (no PrivateRoute) so the
                  redirect from the identity provider lands here before a
                  session token exists in localStorage */}
              <Route path="/sso-callback">
                <SsoCallback />
              </Route>

              <PrivateRoute path="/rights-matrix">
                <RightsMatrix />
              </PrivateRoute>
              {/* Email course-start landing page — public, no auth required.
                  Saves the course destination in sessionStorage then triggers
                  SSO login so the user is authenticated before reaching the course. */}
              <Route path="/email-course-start">
                <EmailCourseStart />
              </Route>

              <Route path="/auth">
                <Auth />
              </Route>
              {/* <Route path="/eccltable" element={<eccltable />} />
              <Route path="/market">
                <Market />
              </Route> */}
              <Route path="/survey-response/:formId/:surveyUseId">
                <ExternalUserFormView />
              </Route>
              <Route path="/public/survey/:id">
                <PublicSurvey />
              </Route>
              <Route path="/survey/public/:id">
                <PublicSurvey />
              </Route>
              <Route path="/external-report/:encyptedKey">
                <ExternalReportModal />
              </Route>
              <Route path="/safetythought/externalthought/:reference_id">
                <ExternalThoughtModal />
              </Route>
              <Route path="/poll/external/:poll_id">
                <ExternalPollModal />
              </Route>
              <Route path="/thankyou/externalpage">
                <ThankYouSafetyPage />
              </Route>
              <Route path="*" exact={true} component={PageNotFound} />
            </Switch>
          </Router>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
}

export default App;